import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { fetchCategories, fetchFormats } from "../_actions/slidePresetActions";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import { StyledMarketPlaceSwiperButton } from "../_components/styled/details/stylesDetails";
import {
  StyledFormatCard,
  StyledMarketplaceFooter,
  StyledMarketplaceFrameDescription,
  StyledMarketplaceProjectFormatTitle,
  StyledTemplateFormatsSwiperContainer,
} from "../_components/styled/home/stylesHome";
import {
  StyledCategories,
  StyledMarketplaceDesignCard,
} from "../_components/styled/styles";
import { createStory } from "../_actions/storiesActions";
import dashboardArtBoardPlaceholder from "../assets/images/dashboardArtBoardPlaceholder.png";
import Format from "string-format";
import {TEMPLATES_BY_FORMAT_SCREEN} from "../_utils/routes";
import { withRouter } from "react-router-dom";
import { FETCH_FORMATS } from "../_actions/endpoints";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import CustomSizeProjectModal from "../_components/common/CustomSizeProjectModal";
import { FaChevronLeft, FaChevronRight, FaPlus } from "react-icons/fa";
import { Button,Box } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

const all = { id: "all", title: "all", display_name: "For you" };

class TemplateFormatsSwiper extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.state = {
      showCustomStorySizeModal: false,
      selectedCategory: all,
      presets: [],
    };
  }

  componentDidMount() {
    this.props
      .fetchCategories(this.props, this.signal.token)
      .then((results) => {
        var requestedCategory = results.find((obj) => {
          return obj.title === this.props.requestedFormat;
        });
        this.fetchFormats(requestedCategory ? requestedCategory.id : "");
        this.setState({
          selectedCategory: requestedCategory ? requestedCategory : all,
        });
      })
      .catch((error) => {
        console.error("Failed to fetch formats");
      });
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  fetchFormats(key = "") {
    axios
      .get(Format(FETCH_FORMATS, key))
      .then((res) => {
        this.setState({
          presets: res.data.results,
        });
      })
      .catch((error) => {
        this.props.handleHTTPError(error, this.props);
      });
  }

  onFilterChange = (key) => {
    this.setState({ selectedCategory: key.id }, () => {
      this.fetchFormats(key.id === "all" ? "" : key.id);
    });
  };

  handleClick = (format) => {
    const { searchTerm } = this.props;
    const url = Format(TEMPLATES_BY_FORMAT_SCREEN, format?.title);

    this.props.history.push({
      pathname: encodeURI(url),
      search: searchTerm?.length > 0 ? `?search=${searchTerm}` : "",
    });
    // this.props.history.go(0);
  };

  toggleCustomSizePopup = () => {
    this.setState((state) => ({
      selectedCategory: "custom",
      showCustomStorySizeModal: !state.showCustomStorySizeModal,
    }));
  };

  onChange = (customWidth, customHeight) => {
    const design = {
      format_type: "custom",
      image_height: customHeight,
      image_width: customWidth,
      title: "Custom " + customHeight + "x" + customWidth + " px",
    };
    this.createStory(design);
  };

  createStory = (data) => {
    this.props.createStory(
      {
        status: "draft",
        template: data.format_type,
        format: data.id,
        title: data.display_name ? data.display_name : data.title,
        image_height: data.image_height,
        image_width: data.image_width,
        story_type: data.story_type,
      },
      this.signal.token,
      this.props
    );
  };

  render() {
    const { t } = this.props;
    const { presetCategories } = this.props.slidePresets;
    const { selectedCategory, presets, showCustomStorySizeModal } = this.state;
    const finalCategories = [
      { id: "all", title: "all", display_name: "For you" },
    ].concat(presetCategories);

    const categoriesView = finalCategories.map((category) => {
      return (
        <Button
          key={category.id}
          variant="outline"
          borderRadius="full"
          borderColor={
            selectedCategory.id === category.id ? "primary.400" : "transparent"
          }
          color="gray.100"
          _hover={{ bg: "none", borderColor: "primary.400" }}
          _focus={{ borderColor: "primary.400", bg: "none" }}
          _active={{ borderColor: "primary.400", bg: "none" }}
          onClick={() => this.onFilterChange(category)}
          mr="1rem"
        >
          {category.display_name}
        </Button>
      );
    });

    const formatContent = presets.map((preset, index) => {
      const { id, image_height, image_width, title, image, display_name } =
        preset;
      return (
        <div key={id}>
          <StyledFormatCard location="start-from-srcatch">
            <StyledMarketplaceDesignCard>
              <div
                className="start-from-scratch-thumbnail swiper-thumbnail"
                onClick={() => this.handleClick(preset)}
              >
                <img
                  className="marketplace-template-format-swiper-image"
                  src={!image ? dashboardArtBoardPlaceholder : image}
                  alt={title}
                />
                <StyledMarketplaceFooter>
                  <StyledMarketplaceProjectFormatTitle className="marketplace-template-formats-title">
                    {display_name}
                  </StyledMarketplaceProjectFormatTitle>
                  <StyledMarketplaceFrameDescription className="marketplace-template-formats-description">
                    {image_width} x {image_height} px
                  </StyledMarketplaceFrameDescription>
                </StyledMarketplaceFooter>
              </div>
            </StyledMarketplaceDesignCard>
          </StyledFormatCard>
        </div>
      );
    });

    return (
      <Box
        as={StyledTemplateFormatsSwiperContainer}
        className={`${this.props.toggleVisibility ? "hidden" : "visible"}`}
        display={["none", "none", "none", "block"]}
      >
        <StyledCategories className="pills-container">
          <div>{categoriesView}</div>

          {finalCategories.length > 0 && (
            <>
              <Button
                rightIcon={<FaPlus />}
                variant="solid"
                onClick={() => this.toggleCustomSizePopup()}
              >
                {t("custom_size")}
              </Button>
            </>
          )}
        </StyledCategories>

        {formatContent.length > 0 && (
          <TLDRSwiper swiperParams={marketPlaceTemplateFormatsSwiperParams}>
            {formatContent}
          </TLDRSwiper>
        )}

        {showCustomStorySizeModal && (
          <CustomSizeProjectModal
            onHide={(e) => {
              this.setState({
                selectedCategory: "all",
                showCustomStorySizeModal: false,
              });
            }}
            onYes={this.onChange}
          ></CustomSizeProjectModal>
        )}
      </Box>
    );
  }
}

let marketPlaceTemplateFormatsSwiperParams = {
  spaceBetween: 20, // padding between 2 elements (in px)
  slidesPerView: 6,
  breakpoints: {
    1200: {
      slidesPerView: 6,
    },
    1024: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 4,
    },
    480: {
      slidesPerView: 2,
    },
    320: {
      slidesPerView: 1.5,
    },
  },
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  mousewheel: false,
  containerClass: "marketplace-template-formats-swiper-container",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    disabledClass: "swiper-button-disabled",
  },
  renderPrevButton: () => (
    <StyledMarketPlaceSwiperButton
      className={"swiper-button-prev"}
      variance="left"
    >
      <div className="swiper-button-inner-div">
        <FaChevronLeft />
      </div>
    </StyledMarketPlaceSwiperButton>
  ),
  renderNextButton: () => (
    <StyledMarketPlaceSwiperButton
      className={"swiper-button-next"}
      variance="right"
    >
      <div className="swiper-button-inner-div">
        <FaChevronRight />
      </div>
    </StyledMarketPlaceSwiperButton>
  ),
};

const mapStateToProps = (state) => ({
  slidePresets: state.slidePresets,
});

const mapDispatchToProps = {
  createStory,
  fetchCategories,
  fetchFormats,
  handleHTTPError,
};

export default withTranslation(["common"])(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(TemplateFormatsSwiper))
);
